import { FC, useCallback, useContext } from "react";
import { OrganizationContext } from "../../../../../organizations/common/organization-provider/organization-provider";
import Button from "antd/es/button";
import Empty from "antd/es/empty";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/pro-regular-svg-icons/faExternalLinkAlt";
import { BillingPortalSessionFlowType } from "constellation-sdk";
import { EmptyContainer, ButtonContainer } from "./subscriptions-view.styled";

type SubscriptionsViewProps = {
	organizationId: string
}

export const SubscriptionsView: FC<SubscriptionsViewProps> = ({
	organizationId,
}) => {

	// context
	const { openCustomerBillingPortal } = useContext(OrganizationContext)

	// event handlers
	const handleOpenPortalClick = useCallback(() => {
		openCustomerBillingPortal(BillingPortalSessionFlowType.subscription_update)
	}, [openCustomerBillingPortal])

    return (
		<EmptyContainer>
			<Empty
				description="You can manage your subscription in the Customer Billing Portal"
			>
				<ButtonContainer>
					<Button
						type="primary"
						icon={<FontAwesomeIcon icon={faExternalLinkAlt} />}
						onClick={handleOpenPortalClick}
					>
						Open Customer Billing Portal
					</Button>
				</ButtonContainer>
			</Empty>
		</EmptyContainer>
    )
}